import { useEffect, useRef } from 'react';
import Star from './vfx/star/Star';
import { loadTextureAsync } from 'web-store-modules/packages/asset-loader';
// import { getRandom } from '../../utils/MathHelper.js';

const SPIRE_TEXTURE_URL = 'https://cdn.obsess-vr.com/sams-club/transparent-light.png';


function getRandom(min, max) {
    return Math.random() * (max - min) + min;
}


function getRandomPosition(xRange, yRange, zRange) {
    return { x: getRandom(...xRange), y: getRandom(...yRange), z: getRandom(...zRange)};
}

export default function StarEffect(props) {
    const renderRef = useRef();

    useEffect(() => {
        const { scaleRange, positionRange, scene, starCount, addToRenderLoop, removeFromRenderLoop, randomizeColor } = props;
        // useRef
        const stars = [];
        window.stars = stars;

        (async () => {
            const spireTexture = await loadTextureAsync(SPIRE_TEXTURE_URL);
            var exitCondition = props.determinedPositions? props.determinedPositions.length: starCount;
            for (let i = 0; i < exitCondition; i++) {
                const star = new Star(spireTexture, addToRenderLoop, randomizeColor);
                star.star.material.depthWrite=false;
                star.star.material.depthTest=false;

                if (props.determinedPositions){
                    var pos = props.determinedPositions[i];
                    star.setPosition(pos[0], pos[1], pos[2]);
                }
                else{
                    var pos = getRandomPosition(positionRange.x, positionRange.y, positionRange.z);
                    star.setPosition(pos.x, pos.y, pos.z);
                    
                }
                
                star.lookAt(0, 0, 0);

                const scale = getRandom(...scaleRange);
                star.setScale(scale, scale);

                star.animationUUID = addToRenderLoop()
                stars.push(star);
                star.addToScene(scene);
            }
        })();

        return () => {
            stars.forEach(star => {
                star.removeFromScene();
                removeFromRenderLoop(star.animationUUID);
            });
        }
    }, []);

    return null;
}
